import { materialIssuesGlobalListQuery } from '@/features/material-issues/queries/material-issue-queries'
import { productionReportsGlobalListQuery } from '@/features/production-reports/queries/production-report-queries'
import { ProjectDashboardPage } from '@/features/projects/pages/project-dashboard-page'
import {
  dashboardDeficitsQuery,
  dashboardWorkOrdersQuery,
} from '@/features/projects/queries/dashboard-query'
import { projectQuery } from '@/features/projects/queries/projects-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/$projectId/_layout/')({
  component: ProjectDashboardPage,
  loader: async ({ params, context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(projectQuery(params.projectId)),
      context.queryClient.ensureQueryData(dashboardWorkOrdersQuery(params.projectId)),
      context.queryClient.ensureQueryData(dashboardDeficitsQuery(params.projectId)),
      context.queryClient.ensureQueryData(
        materialIssuesGlobalListQuery({ project_id: params.projectId }),
      ),
      context.queryClient.ensureQueryData(
        productionReportsGlobalListQuery({ project_id: params.projectId }),
      ),
    ])
  },
  staticData: { crumb: messages.crumbs.dashboard },
})
